import React, { useState, useContext } from 'react';
import { TranslationContext } from '../../../contexts/TranslationContext';
import { EditProductRequest, IInteriorMaterial2, InteriorProductMaterialUpdate, IProduct, ProductClient } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { useState2 } from '../../../util/useState2';
import { ProductMaterialsEditor } from './ProductMaterialsEditor';

interface MatProps {
    id: number;
    isActive: boolean;
    name: string;
    externalId: string;
    drawingImageUrl: string | null;
    pictureImageUrl: string | null;
}

export function SingleProductEditor(props: {
    product: IProduct;
    onChange: () => void;
    interiorMaterials: IInteriorMaterial2[];
}) {

    const tc = useContext(TranslationContext);
    const client = useClient(ProductClient);


    const [snapOffset, setSnapOffset] = useState(props.product.snapOffset);
    const [isInteriorActive, setIsInteriorActive] = useState(props.product.isInteriorActive);
    const [isExtraActive, setIsExtraActive] = useState(props.product.isExtraActive);
    const materialProps = useState2(() => {

        return props.interiorMaterials.map<MatProps>(globalMat => {
            const productMat = props.product.materials.find(m => m.interiorMaterialId === globalMat.id);
            return {
                id: globalMat.id,
                isActive: productMat?.isActive ?? false,
                externalId: productMat?.externalId ?? "",
                name: globalMat.defaultName,
                pictureImageUrl: productMat?.pictureImageUrl ?? null,
                drawingImageUrl: productMat?.drawingImageUrl ?? null

            };

        });
    });


    async function edit(evt: React.FormEvent) {
        evt.preventDefault();
        try {
            await client.editProduct(props.product.id, new EditProductRequest({
                snapOffset: snapOffset,
                isInteriorActive: isInteriorActive,
                isExtraActive: isExtraActive,
                materials: materialProps.value
                    .filter(m => m.isActive)
                    .map(m => new InteriorProductMaterialUpdate({
                        interiorMaterialId: m.id,
                        externalId: m.externalId,
                    })),
            }));
        }
        finally {
            props.onChange();
        }
    }

    return (

        <div>
            <h2>
                {tc.translator("admin edit product header", "Rediger produkt {id} {name}", {
                    name: props.product.defaultName,
                    id: props.product.externalId
                })}
            </h2>
            <form onSubmit={edit}>
                <div className="container container-fluid">
                    <div className="row">
                        <div className="row">
                        <div className="col">
                            <div className="form-group">
                                <label htmlFor="product-snap-offset">
                                    {tc.translator(
                                        "admin edit product snapoffset",
                                        "Snap-position (målt fra bunden af produktet)")
                                    }
                                </label>
                                <div className="input-group">
                                    <input type="number"
                                        className="form-control"
                                        id="prosuct-snap-offset"
                                        value={snapOffset}
                                        onChange={evt => setSnapOffset(evt.target.valueAsNumber)}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">mm</span>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group form-check">
                                <input id="product-is-interior"
                                    className="form-check-input"
                                    checked={isInteriorActive}
                                    type="checkbox"
                                    onChange={evt => setIsInteriorActive(evt.target.checked)}
                                />
                                <label htmlFor="product-is-interior">
                                    {tc.translator(
                                        "admin edit product is interior active",
                                        "Interiør-vare")
                                    }
                                </label>
                            </div>

                            <div className="form-group form-check">
                                <input id="product-is-extra"
                                    className="form-check-input"
                                    checked={isExtraActive}
                                    type="checkbox"
                                    onChange={evt => setIsExtraActive(evt.target.checked)}
                                />
                                <label htmlFor="product-is-extra">
                                    {tc.translator(
                                        "admin edit product is extra active",
                                        "Løssalgs-vare")
                                    }
                                </label>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div className="row">
                        <ProductMaterialsEditor
                            onChange={props.onChange}
                            productId={props.product.id}
                            interiorMaterials={props.interiorMaterials}
                            productMaterials={props.product.materials}
                            matProps={materialProps}
                        />
                    </div>

                    <div className="row" style={{ marginTop: "20px" }}>

                        <button className="btn btn-primary" type="submit">
                            {tc.translator("admin edit product button", "Gem")}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}
